import React, { FC } from 'react';

import { Box, Button2, CloseModalButton, DialogModal, DialogModalProps } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';
import { useAction } from 'Modules/core/redux';

import { modalClassNames, useModalContext } from '../Messaging';
import { messagingActions } from '../../state/actions';


export type ErrorModalProps = Pick<DialogModalProps, 'title' | 'text'>;

const ErrorModalComponent: FC<ErrorModalProps> = props => {
    const { t } = useTranslation('errorModal');
    const { modal } = useModalContext();
    const close = useAction(() => messagingActions.hideMessage(modal.id), [modal.id]);
    return (
        <Box>
            <CloseModalButton onClick={close} size='small' variant='stroke' />
            <DialogModal {...props}>
                <Button2 variantType='brand' onClick={close} data-testid='button-close'>
                    {t('close')}
                </Button2>
            </DialogModal>
        </Box>
    );
};

export const ErrorModal = {
    component: ErrorModalComponent,
    containerClass: modalClassNames.contentDfa,
    position: 'center',
};
